import { useEffect, useRef } from 'react';

export function useFadeIn() {
  const ref = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
          } else {
            entry.target.classList.remove('visible');
          }
        });
      },
      { threshold: 0.12 }
    );

    const el = ref.current;
    if (el) {
      el.classList.remove('visible');
      observer.observe(el);
    }
    return () => { if (el) observer.unobserve(el); };
  }, []);

  return ref;
}